import type { Option } from '../../types';

export const PERIOD_OPTIONS: Option<string>[] = [
    { displayName: 'За 7 дней', value: '7' },
    { displayName: 'За 14 дней', value: '14' },
    { displayName: 'За 30 дней', value: '30' },
    { displayName: 'За весь период', value: 'undefined' },
];
